<div class="container">
  <div class="box-button">
    <mat-spinner
      *ngIf="process"
      diameter="32"
      strokeWidth="2"
      color="warn"
    ></mat-spinner>
    <button mat-icon-button (click)="handle()">
      <mat-icon [class]="process ? 'box-img box-img-no-border' : 'box-img'">{{
        process ? "close" : "save_alt"
      }}</mat-icon>
    </button>
  </div>
</div>
